import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "wdw-news-thought-infinite-list pt-1",
  ref: "thoughtListEl"
}
const _hoisted_2 = {
  key: 0,
  class: "pt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_thought_in_list = _resolveComponent("thought-in-list")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.thoughtsLoading && !$setup.thoughtsAvailable)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($setup.errorMsg.content !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Message, {
                  severity: $setup.errorMsg.severity,
                  closeable: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.errorMsg.content), 1)
                  ]),
                  _: 1
                }, 8, ["severity"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.thoughts, (thought) => {
      return (_openBlock(), _createElementBlock("div", {
        key: thought.id
      }, [
        _createVNode(_component_thought_in_list, {
          thought: thought,
          thoughtListHeight: $props.thoughtListHeight
        }, null, 8, ["thought", "thoughtListHeight"])
      ]))
    }), 128)),
    _createElementVNode("div", null, [
      ($setup.thoughtsLoading)
        ? (_openBlock(), _createBlock(_component_vue_loading, {
            key: 0,
            loadingMessage: "News werden geladen..."
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Paginator, {
        rows: $setup.pager.entries_per_page,
        totalRecords: $setup.pager.total_entries,
        onPage: _cache[0] || (_cache[0] = ($event: any) => ($setup.onPageChange($event)))
      }, null, 8, ["rows", "totalRecords"])
    ])
  ], 512))
}